import {configureStore} from '@reduxjs/toolkit';
// Or from '@reduxjs/toolkit/query/react'
import {setupListeners} from '@reduxjs/toolkit/query';
import {rtkQueryApi} from '~/shared/api/rtk-query-api';
import userSlice from '../../features/user/model/slices/user-slice';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [rtkQueryApi.reducerPath]: rtkQueryApi.reducer,
    user: userSlice.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(rtkQueryApi.middleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
